import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../index';
import { TOGGLE_SEMAPHORE_COLUMN } from './types';
import config from '../../Config';

interface SemaphoreFeatureProviderProps {
    children: React.ReactNode;
}

export const SemaphoreFeatureProvider: React.FC<SemaphoreFeatureProviderProps> = ({ children }) => {
    const dispatch = useDispatch();
    const isSemaphoreEnabled = useSelector<StoreState, boolean | undefined>(
        state => state.featureToggle.semaphoreColumn
    );

    useEffect(() => {
        // Initialize semaphore feature flag from config if not already set
        if (isSemaphoreEnabled === undefined) {
            const semaphoreEnabled = config.features?.semaphore_column?.enabled ?? false;
            dispatch({
                type: TOGGLE_SEMAPHORE_COLUMN,
                payload: semaphoreEnabled
            });
        }
    }, [dispatch, isSemaphoreEnabled]);

    return <>{children}</>;
};

export default SemaphoreFeatureProvider;
